import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    Box,
    Typography,
    Container,
    Card,
    CardMedia,
    CircularProgress,
    Grid,
} from "@mui/material";

function EnterpriseIOSApp() {
    const [enterpriseios, setEnterpriseios] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios
            .get("/files/enterpriseMobility/enterprise_iosApp.txt")
            .then((res) => {
                setEnterpriseios(res.data);
                setLoading(false);
            })
            .catch((err) => {
                console.error("Error fetching data:", err);
                setLoading(false);
            });
    }, []);

    return (
        <Container maxWidth="lg" sx={{ py: 2 }}>
            {/* Title */}
            <Typography
                variant="h3"
                align="center"
                gutterBottom
                sx={{
                    fontWeight: "bold",
                    color: "#030366",
                    mt: 7,
                    fontSize: {
                        xs: "1.8rem",  // mobile (~h4)
                        sm: "2.2rem",  // tablet (~h3)
                        md: "2.8rem",  // laptop (~h3+)
                        lg: "3rem",    // desktop (~h2)
                    },
                }}
            >
                Enterprise IOS App Development
            </Typography>

            {loading ? (
                <Box display="flex" justifyContent="center" mt={4}>
                    <CircularProgress color="secondary" />
                </Box>
            ) : (
                <Grid container spacing={4} alignItems="flex-start">
                    {/* Content Section */}
                    <Grid item xs={12} md={7}>
                        {enterpriseios &&
                            enterpriseios.map((item, index) => (
                                <Box key={index} mb={3}>
                                    {typeof item === "string" ? (
                                        <Typography
                                            variant="body1"
                                            sx={{
                                                mb: 2,
                                                textAlign: "justify",
                                                fontSize: "18px",
                                            }}
                                        >
                                            {item}
                                        </Typography>
                                    ) : (
                                        Object.entries(item).map(([key, value], subIndex) => (
                                            <Box key={subIndex} mb={2}>
                                                <Typography
                                                    variant="h5"
                                                    sx={{
                                                        color: "#030366",
                                                        fontWeight: "bold",
                                                        mb: 1,
                                                    }}
                                                >
                                                    {key}
                                                </Typography>
                                                <Typography
                                                    variant="body1"
                                                    sx={{
                                                        mb: 1,
                                                        textAlign: "justify",
                                                        fontSize: "18px",
                                                    }}
                                                >
                                                    {value}
                                                </Typography>
                                            </Box>
                                        ))
                                    )}
                                </Box>
                            ))}
                    </Grid>
                </Grid>
            )}
        </Container>
    );
}

export default EnterpriseIOSApp;
